module.exports = __webpack_public_path__ + "static/social-media-1fd178200b57514930f57ac6e8cf7e79.jpg";